(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/utils.js');
"use strict";


(function (svs) {
  'use strict';

  svs.tur.start_subscription.utils = {
    getUrlParam(param) {
      const href = location.href;
      const reg = new RegExp("[?&]".concat(param, "=([^&#]*)"), 'i');
      const queryStringParam = reg.exec(href);
      return queryStringParam ? queryStringParam[1] : null;
    },
    clearUrlParam(paramToClear) {
      svs.utils.url.refreshQueryString();
      const {
        [paramToClear]: currentParamToClear
      } = svs.utils.url.queryString;
      if (currentParamToClear) {
        let targetString = '';
        let delim = '?';
        for (const param in svs.utils.url.queryString) {
          if (param !== paramToClear) {
            targetString = "".concat(targetString).concat(delim).concat(param, "=").concat(encodeURIComponent(svs.utils.url.queryString[param]));
            delim = '&';
          }
        }
        window.history.replaceState({}, '', "".concat(window.location.pathname).concat(targetString));
        svs.utils.url.refreshQueryString();
      }
    },
    updateQuerystringWithParamAndValue(param, value) {
      this.clearUrlParam(param);
      svs.utils.url.refreshQueryString();
      let targetPath = svs.utils.url.currentPathEncodedParams();
      targetPath = svs.utils.url.updateQueryStringParameter(targetPath, param, value);
      window.history.replaceState({}, '', targetPath);
    },
    preventDoubleClick(buttonTarget) {
      buttonTarget.setAttribute('disabled', 'disabled');
      setTimeout(() => {
        buttonTarget.removeAttribute('disabled');
      }, 5000); 
    }
  };
})(svs, jQuery);

 })(window);